import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { base_url } from "../utils/baseUrl";
import { useNavigate } from "react-router-dom";
import TopSellingProducts from '../components/TopSellingProducts';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [salesData, setSalesData] = useState({ datasets: [] });
  const [topCustomers, setTopCustomers] = useState([]);
  const [topReviews, setTopReviews] = useState([]);
  const [dashboardStats, setDashboardStats] = useState({
    totalOrders: 0,
    totalProducts: 0,
    totalSales: 0,
  });
  const [salesType, setSalesType] = useState('daily');
  const navigate = useNavigate();

    const adminToken = localStorage.getItem("adminToken");
console.log("Admin Token:", adminToken);

 useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);
  
  useEffect(() => {
    fetchDashboardData();
    fetchTopCustomers();
    fetchTopReviews();
  }, [salesType]);

  const fetchDashboardData = async () => {
    try {
      const response = await axios.get(`${base_url}/api/reviews/getDashboardData`);
      const dashboardData = response.data;
      setDashboardStats({
        totalOrders: dashboardData.totalOrders,
        totalProducts: dashboardData.totalProducts,
        totalSales: dashboardData.totalSales,
      });

      const chartData = {
        labels: ['January', 'February', 'March', 'April'],
        datasets: dashboardData.totalSales > 0 ? [
          {
            label: 'Total Sales',
            data: [dashboardData.totalSales, 3000, 4000, 3500],
            borderColor: 'rgba(75,192,192,1)',
            backgroundColor: 'rgba(75,192,192,0.2)',
            tension: 0.1,
          },
        ] : []
      };
      setSalesData(chartData);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const fetchTopCustomers = async () => {
    try {
      const response = await axios.get('/api/top-customers');
      setTopCustomers(response.data);
    } catch (error) {
      console.error("Error fetching top customers:", error);
    }
  };

  const fetchTopReviews = async () => {
    try {
      const response = await axios.get('/api/top-reviews');
      setTopReviews(response.data);
    } catch (error) {
      console.error("Error fetching top reviews:", error);
    }
  };

  const handleSalesTypeChange = (type) => {
    setSalesType(type);
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.dataset.label + ': ' + context.raw;
          },
        },
      },
    },
  };

  return (
    <div>
      <h2>Dashboard</h2>
      
      <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px' }}>
        <div style={{ textAlign: 'center' }}>
          <h3>Total Orders</h3>
          <p>{dashboardStats.totalOrders}</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3>Total Products</h3>
          <p>{dashboardStats.totalProducts}</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3>Total Sales</h3>
          <p>${dashboardStats.totalSales}</p>
        </div>
      </div>

      <div>
        <button onClick={() => handleSalesTypeChange('daily')}>Daily</button>
        <button onClick={() => handleSalesTypeChange('weekly')}>Weekly</button>
        <button onClick={() => handleSalesTypeChange('monthly')}>Monthly</button>
        <button onClick={() => handleSalesTypeChange('2-day')}>2 Day</button>
      </div>

      <div>
        <h3>Sales Chart</h3>
        {salesData.datasets.length > 0 ? (
          <Line data={salesData} options={options} />
        ) : (
          <p>No data to show</p>
        )}
      </div>

      <div>
        <h3>Top 5 Customers</h3>
        {topCustomers.length > 0 ? (
          <table border="1" cellPadding="10" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Customer</th>
                <th>Sales</th>
              </tr>
            </thead>
            <tbody>
              {topCustomers.map((customer, index) => (
                <tr key={index}>
                  <td>{customer.name}</td>
                  <td>{customer.sales}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No customers data to show</p>
        )}
      </div>

      <div>
        <h3>Top 5 Reviews</h3>
        {topReviews.length > 0 ? (
          <table border="1" cellPadding="10" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Review</th>
                <th>Rating</th>
              </tr>
            </thead>
            <tbody>
              {topReviews.map((review, index) => (
                <tr key={index}>
                  <td>{review.review}</td>
                  <td>{review.rating} / 5</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No reviews data to show</p>
        )}
      </div>

      {/* Top Selling Products Section */}
      <div style={{ marginTop: '30px' }}>
        <TopSellingProducts />
      </div>
    </div>
  );
};

export default Dashboard;
